<script>
  import { createEventDispatcher } from 'svelte';
  import { Dropdown, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { NotificationsMenu } from '@client/components/notifications-menu';

  const dispatcher = createEventDispatcher();

  /**
   * A boolean that indicates if sidebar is collapsed or closed.
   * @type {boolean}
   * @default false
   */
  export let collapsed = false;

  /**
   * @typedef {Object} Notification
   * @property {'adclick' | 'attachmentdownload' | 'attachmentview' | 'beaconview' | 'linkclick' | 'msg' | 'videoactivity' | 'websitevisit'} objecttype - The type of activity.
   * @property {string} recipient - The email recipient of the notification.
   * @property {string} msgsubject - The email subject of the notification.
   * @property {boolean} unread - Indicates whether the notification is unread.
   * @property {Date} utcts - the date and time of the notification.
   */

  /**
   * The array of notifications, if any.
   * @type {Array<{Notification}>}
   * @default []
   */
  export let notifications = [];
</script>

{#if !collapsed && notifications?.length > 0}
  <Dropdown {...$$restProps} dropup class="w-100">
    <DropdownToggle tag="div" class="d-flex align-items-center w-100">
      <slot />
    </DropdownToggle>
    <DropdownMenu class="w-100 p-0">
      <NotificationsMenu {notifications} on:viewed={() => dispatcher('viewed')} />
    </DropdownMenu>
  </Dropdown>
{:else}
  <slot />
{/if}
